import { computed, defineComponent, useCssModule } from '@nuxtjs/composition-api';
import { DEFAULT_ATTRS } from '.';
export default defineComponent({
    name: 'ArticleActions',
    props: {
        actions: {
            default: () => ['copy', 'share', 'bookmark'],
            type: [String, Object, Array],
        },
        size: {
            default: 'thin',
            type: String,
            validator(value) {
                return ['small', 'thin', 'wide'].includes(value);
            },
        },
        theme: {
            default: 'light',
            type: String,
            validator(value) {
                return ['a11y', 'light', 'dark'].includes(value);
            },
        },
        withShadow: {
            default: true,
            type: Boolean,
        },
    },
    emits: ['click'],
    setup(props, { emit }) {
        const css = useCssModule();
        const validTypes = ['a11y', 'speech', 'bookmark', 'close', 'copy', 'share'];
        const currentActions = computed(() => {
            // If actions is string
            if (isString(props.actions)) {
                return [createActionFromString(props.actions)];
            }
            // If actions is object
            if (isObject(props.actions)) {
                return [createActionFromObject(props.actions)];
            }
            // If actions is array
            return props.actions.map((action) => {
                if (!(isString(action) || isObject(action))) {
                    console.error(action, 'is invalid action type. Action type must be a string or object');
                }
                if (isObject(action)) {
                    return createActionFromObject(action);
                }
                return createActionFromString(action);
            });
        });
        function createActionFromString(action) {
            validateType(action);
            return {
                type: action,
                attrs: DEFAULT_ATTRS,
            };
        }
        function createActionFromObject(action) {
            let [entries] = Object.entries(action);
            if (!entries) {
                entries = ['', DEFAULT_ATTRS];
                console.error('Object must not be empty');
            }
            const [type, attrs] = entries;
            if (!isObject(attrs)) {
                console.error('Action attrs must be an object');
            }
            if (type) {
                validateType(type);
            }
            return {
                type,
                attrs: {
                    ...DEFAULT_ATTRS,
                    ...attrs,
                },
            };
        }
        function validateType(type) {
            if (!validTypes.includes(type)) {
                const types = '"' + validTypes.join('", "') + '"';
                console.error(type, 'is not valid action type.\nAction type must be one of the following:', types);
            }
        }
        function isString(value) {
            return typeof value === 'string';
        }
        function isObject(value) {
            return typeof value === 'object' && value instanceof Object && !Array.isArray(value);
        }
        function close(event) {
            emit('close', event);
        }
        return {
            close,
            css,
            currentActions,
        };
    },
});
